import { render, staticRenderFns } from "./DocumentNewForm.vue?vue&type=template&id=35d9f00e&"
import script from "./DocumentNewForm.vue?vue&type=script&lang=js&"
export * from "./DocumentNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports